import {ReactComponent as HarekatAvalIcon} from './harekatAval.svg'

function HarekatAval() {
  return <HarekatAvalIcon />
}

export default HarekatAval
